module.exports = fetch;


//////////////////
// WEBPACK FOOTER
// external "fetch"
// module id = 252
// module chunks = 1